// noinspection JSUnresolvedReference
/** biome-ignore-all lint/correctness/noUndeclaredVariables: We need this */

import playLiveOpenGraph from "@/assets/playlive-og-image-preview.jpg";
import { getAssetImageUrl } from "@/util/common.js";

export const isTestMode = import.meta.env.VITE_APP_ENV === "qa";

export const isTwitchEnabled =
  !import.meta.env.VITE_TWITCH_DISABLED || import.meta.env.VITE_TWITCH_DISABLED !== "true";

export const CHARITY = {
  TILTIFY: "tiltify",
  TWITCH: "twitch",
};

export const siteDescription = isTestMode
  ? `Keep everyone up-to-date on your fundraising progress, use themed graphics on your stream, connect with chat through new interactive chatbot commands, and easily share facts.`
  : `Keep everyone up-to-date on your fundraising progress, use themed graphics on your stream, connect with chat through new interactive chatbot commands, and easily share facts about the life-saving mission of St. Jude Children's Research Hospital.`;

export const defaultOpenGraphImage = getAssetImageUrl(playLiveOpenGraph);
